module.exports = __webpack_public_path__ + "img/Watney6.a1011e82.jpg";